import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class AssetTypesService {

  constructor(private http: HttpClient) { }

  public getAllAssetTypesNoPagination() {
    return this.http.get(environment.apiUrl + 'api/ext-asset-category?size=10000000&page=0')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public getAllAssetTypes(pagination) {

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    return this.http.get(environment.apiUrl + 'api/ext-asset-category' + paginationString, { observe: 'response' })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }


  public getAllAssetTypesForSiteType(id) {
    return this.http.get(environment.apiUrl + 'api/ext-asset-category/by-site-type/' + id + '?size=10000000&page=0')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public getAllAssetTypesForSite(siteId) {
    return this.http.get(environment.apiUrl + 'api/ext-asset-category/by-site/' + siteId + '?size=10000000&page=0')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public getAllCompetenciesForAssetType(id) {
    return this.http.get(environment.apiUrl + 'api/ext-competency-type/by-asset-category/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public createAssetType(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-asset-category/create', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Handle Responses
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }

  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }

}
